import _typeof from 'babel-runtime/helpers/typeof';
import _isNil from 'lodash/isNil';

import { notAllowed } from './outfit-parser';

/**
 * @param {Array} allowedOptions - Allowed values of outfit
 * @return {*}
 */
export default function outfitPropValidator(allowedOptions) {
  var validateOptionsSet = function validateOptionsSet(props, propName) {
    var componentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Anonymous';

    var value = props[propName] || '';

    if (typeof value !== 'string') {
      return new Error('Invalid prop `' + propName + '` of type `' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '` supplied to `' + componentName + '`, expected a string.');
    }

    var diff = notAllowed(allowedOptions, value);

    if (diff.length) {
      return new Error('Invalid prop `' + propName + '` with string set of `' + diff.join(', ') + '` supplied to `' + componentName + '`, expected a subset of `' + allowedOptions.join(', ') + '`.');
    }
    return null;
  };

  var validateOptionsSetRequired = function validateOptionsSetRequired(props, propName) {
    var componentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Anonymous';

    var value = props[propName];
    if (_isNil(value)) {
      return new Error('The prop `' + propName + '` is marked as required in `' + componentName + '` but its value is `' + value + '`.');
    }
    return validateOptionsSet(props, propName, componentName);
  };

  validateOptionsSet.isRequired = validateOptionsSetRequired;

  return validateOptionsSet;
}